<style scoped lang="scss">
@import "mobile";
  .wrap-app{
    background: #fafafa;
  }
  .main-top{
    padding:0 15px;
    background: url("../../assets/images/mobile/top_bg.png") no-repeat left -50px;
    background-size: 100% auto;
    .logo{
      width:120px;
      margin:30px 0;
    }
    .card-lists{
      background: #fff;
      box-shadow: 0 2px 6px rgba(0,0,0,.1);
      padding:10px 15px;
      li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:20px 0;
        border-bottom: 1px solid #F5F5F5;
        font-size: 14px;
        &:last-child{
          border-bottom: 0;
        }
        .icon{
          width:20px;
          margin-right: 5px;
        }
        .arrow{
          width:8px;
          margin-left: 5px;
        }
        .label{
          display: flex;
          align-items: center;
        }
        .info{
          display: flex;
          align-items: center;
          color: #999;
        }
      }
    }
  }
  .order{
    .order-title{
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      margin-top:20px;
      &:before{
        content: '';
        display: block;
        width:5px;
        height:17px;
        background: #014492;
        margin-right: 5px;
      }
    }
  }
  .order-tabs{
    display: flex;
    justify-content: space-between;
    color: #999;
    text-align: center;
    padding:15px 0;
    font-size: 12px;
    img{
      width:45px;
      margin-bottom: 3px;
    }
  }
  .order-lists{
    li{
      padding:10px;
      background: #fff;
      border-left: 2px solid #014492;
      margin-bottom: 15px;
      font-size: 12px;
      .top{
        display: flex;
        justify-content: space-between;
        color: #999;
        border-bottom: 1px solid #F5F5F5;
        padding-bottom: 10px;
      }
      .status{
        background: #eee;
        font-size: 12px;
        padding:1px 5px;
      }
      .title{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-weight: bold;
        font-size: 14px;
        span{
          color: #999;
          font-weight: normal;
          font-size: 12px;
        }
      }
      .price{
        display: flex;
        justify-content: space-between;
        color: #999;
        margin-top: 10px;
      }
    }
  }
.molecular-item{
  padding:0;
}
.order-lists li{
  border:0;
}
</style>
<template>
  <div class="wrap-app">
    <div class="main-top">
      <div class="tc"><img src="@/assets/images/mobile/logo.png" class="logo"></div>
      <ul class="card-lists">
        <li @click="$router.push('/unbind')">
          <div class="label">
            <img src="@/assets/images/mobile/icon_user.png" class="icon">
            姓名
          </div>
          <div class="info">
            {{memberInfo.realName}} ({{phone}})
            <img src="@/assets/images/mobile/arrow.png" class="arrow">
          </div>
        </li>
        <li>
          <div class="label">
            <img src="@/assets/images/mobile/icon_integral.png" class="icon">
            积分
          </div>
          <div class="info">
            {{points.availablePoints}}
          </div>
        </li>
        <li @click="$router.push('/sample')">
          <div class="label">
            <img src="@/assets/images/mobile/icon_car.png" class="icon">
            发起取样
          </div>
          <div class="info">
            <img src="@/assets/images/mobile/arrow.png" class="arrow">
          </div>
        </li>
      </ul>
    </div>
    <div class="order">
      <div class="order-title">订单</div>
      <ul class="order-tabs">
        <li v-for="(item, index) in orderTabs" :key="index" @click="$router.push(item.ref)">
          <img :src="'./static/images/mobile/icon_' + item.icon + '.png'">
          <p>{{item.name}}</p>
        </li>
      </ul>
      <ul class="order-lists"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
          immediate-check="false">
        <li v-for="item in orderLists" :key="item.id" @click="toDetails(item)">
<!--          <div class="molecular-item" :key="item.id" v-if="item.orderType === 'product_order'">-->
<!--            <div class="top">-->
<!--              <div>订单号：<span class="text-primary">{{item.no}}</span></div>-->
<!--              <span class="status" :class="{'status-danger': item.retainGoods}">{{item.retainGoods ? '部分发货' : '全部已发货'}}</span>-->
<!--            </div>-->
<!--            <ul class="products">-->
<!--              <li v-for="itx in item.productItems" :key="itx.id">-->
<!--                <img :src="itx.goods.mainImgUrl" class="pro-img">-->
<!--                <div class="info">-->
<!--                  <div class="title">-->
<!--                    {{itx.goods.name}}-->
<!--                    <span class="num">x{{itx.quantity}}</span>-->
<!--                  </div>-->
<!--                  <p class="mt5">货号：{{itx.sku.code}}</p>-->
<!--                  <div class="spec mt5">-->
<!--                    规格：{{itx.sku.spec}}-->
<!--                    <span class="fz14 text-primary" v-if="itx.needSendQuantity === 0">发货完成</span>-->
<!--                    <span class="fz14 text-danger" v-else>剩余数：{{itx.needSendQuantity}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--&lt;!&ndash;            <div class="btn-more" @click="bindLoad(index, item.showNums)" v-show="item.items.length > 5 && item.showNums < item.items.length">查看更多</div>&ndash;&gt;-->
<!--            <div class="bot">-->
<!--              共{{item.materialsNum}}件，应付金额：{{item.amount | amount}}元-->
<!--              <span>{{item.createTime | rTime}}</span>-->
<!--            </div>-->
<!--          </div>-->
          <div class="order-item">
            <div class="top">
              <div>订单号：<span class="text-primary">{{item.no}}</span></div>
              <span class="status">{{item.orderStatus === 'ing' ? '进行中' : '已完成'}}</span>
            </div>
            <div class="con">
              <div class="title">{{item.name}}<span>×{{item.materialsNum}}</span></div>
              <div class="price">应付金额：￥{{item.settlementAmount | amount}}<span>{{item.createTime | rTime}}</span></div>
            </div>
          </div>
        </li>
      </ul>
      <div class="btn-more" v-show="loading">加载中</div>
      <div class="btn-more" v-show="total === orderLists.length && orderLists.length > 0">没有更多了</div>
    </div>
  </div>
</template>

<script>
import { customerPoints, coreOrders } from '@/services/api.index'
export default {
  data () {
    return {
      orderTabs: [
        {name: '分子产品', icon: 'molecular', ref: '/molecular'},
        {name: '基因合成', icon: 'gene', ref: '/gene'},
        {name: '引物合成', icon: 'compose', ref: '/primer'},
        {name: 'Sanger测序', icon: 'sunger', ref: '/sunger'},
        {name: '其它项目', icon: 'other', ref: '/other'}
      ],
      memberInfo: this.baseMethods.getLocalObj('memberInfo'),
      phone: '',
      points: {},
      orderLists: [],
      page: 0,
      size: 10,
      total: 0,
      loading: false
    }
  },
  created() {
    this._init()
    this.getPoints()
    this.getCoreOrders()
  },
  methods: {
    // 用户信息
    _init () {
      const mobile = this.memberInfo.mobile
      this.phone = `${mobile.slice(0, 3)}****${mobile.slice(7)}`
    },
    // 积分汇总
    getPoints () {
      customerPoints().then(res => {
        this.points = res.data
      })
    },
    // 订单
    getCoreOrders () {
      const customerId = this.memberInfo.id
      this.$indicator.open()
      const { page, size } = this
      coreOrders(page, size, customerId).then(res => {
        res.data.list.map(item => {
          let title, src
          switch (item.orderType) {
            case 'sequencing_order':
              title = '测序反应数'
              src = '/sunger/order_details'
              break
            case 'gene_order':
              title = '基因合成数'
              src = '/gene/order_details'
              break
            case 'primer_order':
              title = '引物合成数'
              src = '/primer/order_details'
              break
            case 'product_order':
              src = '/molecular/order_details'
              break
            case 'core_project':
              title = item.coreProjectName
              src = '/other/order_details'
              break
          }
          item.name = title
          item.src = src
        })
        this.loading = false
        this.orderLists = this.orderLists.concat(res.data.list)
        this.total = res.data.totalCount
        if (this.orderLists.length === this.total && this.orderLists.length !== 0) {
          this.loaded = true
        }
        this.$indicator.close()
      })
    },
    loadMore () {
      if (!this.loaded) {
        this.loading = true
        setTimeout(() => {
          this.page++
          this.getCoreOrders()
        }, 2000)
      }
    },
    // 跳转到详情页
    toDetails (item) {
      this.$router.push(`${item.src}?id=${item.id}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/index.vue